(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('UIFormAccess', UIFormAccess);

    UIFormAccess.$inject = ['Principal', '$state'];

    function UIFormAccess(Principal, $state) {
        var service = {
                checkStateAccess: checkStateAccess
        };

        return service;

        function checkStateAccess (state) {
            var authorities = $state.get(state).data.authorities;
            return Principal.hasAnyAuthority (authorities);
        }

    }
})();
